<script lang="ts">
    import {getLocalization} from 'src/core';
    import type {Link} from 'src/typings';
    import KpLinksMenu from 'shared/components/kp-links-menu/KpLinksMenu.svelte';

    export let availableExports: Link[];
    const localize = getLocalization();
</script>

<KpLinksMenu links={availableExports}
             dropdownButtonText={localize(/* @kp-localization export.ExportVsechVyhledanych */ 'export.ExportVsechVyhledanych')}
             showIfEmpty={false}
             buttonSize="xs"
             additionalClasses="search-export"/>